import { useTranslate } from '@im/react-localization';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import React, { FC } from 'react';
import { DeleteAcopResponse } from '../../hooks/deleteAcops';
import Typography from '@mui/material/Typography';

export interface DelinkResponsePopUpProps {
  dmr_Action: string;
  handleClose: () => void;
  responseData?: DeleteAcopResponse;
}
const DelinkResponsePopUp: FC<DelinkResponsePopUpProps> = ({
  dmr_Action,
  handleClose,
  responseData,
}) => {
  const translate = useTranslate();
  return (
    <Dialog data-testid="delink-response-pop-up" maxWidth="md" open={true}>
      <DialogTitle>
        {dmr_Action}
        {translate('AcopMaintenance.DeleteAcopResponsePopUpTitle')}
        <IconButton onClick={handleClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography>
          {responseData?.transactionStatus === '400' ? (
            translate('AcopMaintenance.AcopDeleteError')
          ) : (
            <>
              {translate('AcopMaintenance.AcopDeleteSuccess')}
              <strong>
                {translate('AcopMaintenance.AcopDeleteDMRSuccessNote', {
                  requestId: responseData?.dmR_Id,
                })}
              </strong>
              <br />
              {translate('AcopMaintenance.AcopDeleteRedirectedMsgSuccess')}
              <br />
            </>
          )}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="newContained">
          {translate('Common.Okay')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DelinkResponsePopUp;
